import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useUserPositionOption.ts
var DEFAULT_CACHE_STRATEGY = "cache-only";
function useUserPositionOption(id, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Users.GetUserPositionOption.v1, id ? { userPositionOptionId: id } : void 0, {
		cacheStrategy: opts.cacheStrategy || DEFAULT_CACHE_STRATEGY,
		fire: !!id && fire
	});
	return {
		data: data?.userPositionOption,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useUserPositionOption };

//# sourceMappingURL=useUserPositionOption.js.map